import { Router } from 'vue-router';
import { usePermissionStoreWithOut } from '/@/store/modules/permission';
import { PageEnum } from '/@/enums/pageEnum';
import { PAGE_NOT_FOUND_NAME } from '../constant';

export function createPackageGuard(router: Router) {
  const permissionStore = usePermissionStoreWithOut();

  router.beforeEach(async (to, from, next) => {
    // 获取package
    const fromPackage = from.matched[0]?.meta?.package;
    const toPackage = to.matched[0]?.meta?.package;
    if (['/', PageEnum.BASE_LOGIN].includes(from.path) && fromPackage === toPackage) {
      resetMenus(next);
      return;
    }
    // package一致则直接跳转
    if (fromPackage === toPackage) {
      next();
      return;
    }
    // toPackage不为空则过滤对应package菜单
    if (toPackage) {
      // 不是新开页面且不是登录页进入则新开页面
      if (
        from.path !== '/' &&
        from.path !== PageEnum.BASE_LOGIN &&
        from.name !== PAGE_NOT_FOUND_NAME
      ) {
        const { host, protocol, pathname } = window.location;
        const url = `${protocol}//${host}${pathname}` + '#' + to.path;
        window.open(url, `_${toPackage}`);
        next(from);
        return;
      }
      const menus = permissionStore.frontMenuListOrigin;
      const filterMenus = menus.filter((item) => item.meta?.package === toPackage);
      permissionStore.setFrontMenuList(filterMenus);
      permissionStore.setLastBuildMenuTime();
      next();
      return;
    }
    resetMenus(next);
  });

  function resetMenus(next) {
    const packageMap = new Set();
    const menus = permissionStore.frontMenuListOrigin;
    const filterMenus = menus.filter((item) => {
      const { package: itemPackage, hidePackage } = item.meta || {};
      if (!itemPackage) {
        return true;
      }
      // 过滤重名的以及隐藏的package菜单
      if (packageMap.has(itemPackage) || hidePackage) {
        return false;
      }
      packageMap.add(itemPackage);
      return true;
    });
    permissionStore.setFrontMenuList(filterMenus);
    permissionStore.setLastBuildMenuTime();
    next();
  }
}
